import keyMirror from 'keymirror';

export default keyMirror({
  DEFAULT: null,
  FAVORITE: null,
  FEATURED: null
});
